import { Http } from 'Core/utils'

import { ServiceSite } from 'Portals/Customer/Interfaces'

import { baseUrl } from './constants'

export const retrieveServiceSites = (): Promise<ServiceSite[]> =>
	Http.get(`${baseUrl}/current-user`)
